import { render } from "./PlayerLists.vue?vue&type=template&id=1031762a"
import script from "./PlayerLists.vue?vue&type=script&lang=js"
export * from "./PlayerLists.vue?vue&type=script&lang=js"

import "./PlayerLists.vue?vue&type=style&index=0&id=1031762a&lang=css"

import exportComponent from "/github/workspace/timmies-helper-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__